import { render, staticRenderFns } from "./BroadcastSetup.vue?vue&type=template&id=3de21e93"
import script from "./BroadcastSetup.vue?vue&type=script&lang=js"
export * from "./BroadcastSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports